import { ComparatorEnum } from '../../../models/interface/comparator.enum';
import { PermissionProfileOption } from '../keys/permissionProfile.enum';
import { PermissionOption } from '../models/permissionOption.interface';

export const permissionProfile: PermissionOption[] = [
  {
    code: 'P333',
    option: PermissionProfileOption.PROFILE_COMMON_LOGIN,
    permissions: ['profile.common.login'],
    comparator: ComparatorEnum.EXACT,
  },
  {
    code: 'P333',
    option: PermissionProfileOption.PROFILE_MANAGE_BASIC_INFORMATION,
    permissions: ['profile.manage.basicInformation'],
    comparator: ComparatorEnum.EXACT,
  },
];
